function u(n) {
  for (var t = 0, r = !1, l = n.length - 1, a; l >= 0; )
    a = parseInt(n.charAt(l), 10), r && (a *= 2, a > 9 && (a = a % 10 + 1)), r = !r, t += a, l--;
  return t % 10 === 0;
}
var h = u;
export {
  h as l
};
